import React, { useEffect, useMemo, useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import DesktopModalLayout from "src/bepaid/components/Modal/components/DesktopModalLayout";
import MainLayout from "src/bepaid/layouts/MainLayout";

import ROUTES from "src/bepaid/routes";
import { history } from "src/ipm-shared/store";

import FetchSkeleton from "src/bepaid/components/Skeleton";
import Button from "src/bepaid/components/Form/controls/Button";
import Progress from "src/bepaid/components/Progress";

import * as uuidv1 from "uuid/v1";
import _get from "lodash-es/get";
import _isEmpty from "lodash-es/isEmpty";
import _lowerCase from "lodash-es/lowerCase";

import { useMakePaymentUrlParams } from "src/bepaid/pages/Payments/hooks";

import UtilityItem from "./UtilityItem";
// import NumberUtil from "src/ipm-shared/Utils/Number";

import styles from "../ExpandBox/ExpandboxContainer.module.scss";
import { FORM } from "src/ipm-shared/store/model/Payee/const";
import { purposeByEntity } from "src/bepaid/pages/Payments/const";
import { invokeMessage } from "src/bepaid/components/Message";
// import FeatureGateUtil from "src/ipm-shared/components/FeatureGating/Util";

const View = (props: any) => {
  const [loading, setLoading] = useState(false);

  const { entity, replaceRouteWithParams } = useMakePaymentUrlParams();
  const purpose = purposeByEntity[entity as keyof typeof purposeByEntity];

  const payee = props.selectedPayees[0];

  const handleClickAddExtraPayee = (payee: any) => {
    const {
      accountNumber,
      bankBSBId,
      bankId,
      bankCode,
      bsbCode,
      currencyId,
      defaultAmount,
      defaultComments,
      id,
      name,
      isUnsupported,
      unsupportedMessage
    } = payee;

    let uid = uuidv1();
    let updateAmount = defaultAmount;
    if (payee.uid) {
      uid = payee.uid;
      updateAmount = defaultAmount / 100;
    }

    props.updateExtraPayee(id, uid, {
      accountNumber,
      bankBSBId,
      bankCode,
      bankId,
      bsbCode,
      currencyId,
      defaultAmount: updateAmount,
      defaultComments,
      files: [],
      id,
      isUnsupported,
      name,
      refundedAmount: 0,
      uid,
      unsupportedMessage
    });
  };

  const setExtraPayeeValue = (
    payeeId: number,
    uid: string,
    prop: any,
    value: string
  ) => {
    props.updateExtraPayee(payeeId, uid, {
      ...props.selectedPayees.filter((p: any) => p.id === payeeId)[0]
        .extraPayees[uid],
      [prop]: value
    });
  };

  const handleClickRemoveExtraPayee = (payee: any, uid: string) => {
    props.removeControlPattern(new RegExp(`${payee.id}_${uid}`));
    props.deleteExtraPayee(payee.id, uid);
  };

  const renderExtraPayees = (payee: any) => {
    return Object.keys(payee.extraPayees).map((uid: string) => {
      return (
        <UtilityItem
          key={uid}
          payee={payee}
          extraPayeeUid={uid}
          setExtraPayeeValue={setExtraPayeeValue}
          onClickDeletePayee={handleClickRemoveExtraPayee.bind(
            null,
            payee,
            uid
          )}
          accountCountryCode={props.accountCountryCode}
          accountCurrencyId={props.accountCurrencyId}
          accountCountryId={props.accountCountryId}
          list={utilityProviders}
        />
      );
    });
  };

  const [utilityProviders, setUtilityProviders] = useState<any[]>([]);

  useEffect(() => {
    if (!props.isHongKongAccount) {
      history.push(
        replaceRouteWithParams(ROUTES.PAYMENTS_CREATION, {
          newEntity: "entity",
          newAction: "select"
        })
      );
    } else {
      props.fetchPayees({
        type: "utility",
        noRedirect: true,
        isWallex: false,
        pageCount: 1000,
        cb: (_: any, payees: any) => {
          const utilities = payees.filter(
            (payee: any) => payee.purposeId === 9 && payee.editDisabled === true
          );
          setUtilityProviders(utilities);

          if (props.selectedPayeesId) {
            props.selectPayees({
              ids: [props.selectedPayeesId],
              purpose,
              removedIds: "all"
            });
          }
        }
      });
    }
  }, []);

  const moveForward = () => {
    setLoading(true);

    setTimeout(() => {
      props.validatePaymentPayeeSubmit(
        purpose,
        false,
        {
          cb: (err?: any) => {
            if (err) {
              invokeMessage("error", err.message);
            } else {
              history.push(
                replaceRouteWithParams(ROUTES.PAYMENTS_CREATION, {
                  newAction: "schedule"
                })
              );
            }
          }
        },
        setLoading
      );
    }, 500);
  };

  const submitLabel = useMemo(() => {
    return loading ? "Moving forward..." : "Move forward";
  }, [loading]);

  const onBack = () => {
    props.setSupplierPayoutType(null);
    props.removeForm(FORM);
    history.goBack();
  };

  const renderBtnSubmit = () => {
    return (
      <>
        <Button
          wrapperClassName={styles.wrapperButton}
          onClick={moveForward}
          type="primary"
          htmlType="button"
          loading={loading || _isEmpty(payee)}
          autoScrollToFirstError={true}
        >
          {submitLabel}
        </Button>
      </>
    );
  };

  const renderDesktopView = () => {
    return (
      <DesktopModalLayout
        maxWidth450={true}
        onSubmit={moveForward}
        title={props.titleLabel}
        onClose={props.onClose}
        onBack={onBack}
        progress={
          <Progress colors={["#937CF2", "#A581E8"]} value={props.progress} />
        }
        submitButtonClassName={""}
        btnSubmit={renderBtnSubmit()}
      >
        {renderContent()}
      </DesktopModalLayout>
    );
  };

  const renderMobileView = () => {
    return (
      <MainLayout
        header={{
          title: props.titleLabel,
          hideMenu: true,
          onBack,
          onClose: props.onClose,
          progress: (
            <Progress colors={["#937CF2", "#A581E8"]} value={props.progress} />
          )
        }}
        footer={renderBtnSubmit()}
      >
        {renderContent()}
      </MainLayout>
    );
  };

  const renderContent = () => {
    return (
      <div className={styles.wrapper}>
        <FetchSkeleton loading={false}>
          <div className={styles.groupContainer}>
            <div>
              <UtilityItem
                payee={payee}
                accountCountryCode={props.accountCountryCode}
                accountCurrencyId={props.accountCurrencyId}
                accountCountryId={props.accountCountryId}
                list={utilityProviders}
              />
              {!_isEmpty(payee) && renderExtraPayees(payee)}

              {!_isEmpty(payee) && (
                <button
                  onClick={handleClickAddExtraPayee.bind(null, payee)}
                  className={styles.btnAdd}
                >
                  Make multiple utility payments to this utility provider.
                </button>
              )}
            </div>
          </div>
        </FetchSkeleton>
      </div>
    );
  };

  return (
    <>
      <BrowserView>{renderDesktopView()}</BrowserView>
      <MobileView>{renderMobileView()}</MobileView>
    </>
  );
};

export default View;
